import { render, staticRenderFns } from "./data-staff-info.vue?vue&type=template&id=fcf7ba3a&scoped=true&"
import script from "./data-staff-info.vue?vue&type=script&lang=js&"
export * from "./data-staff-info.vue?vue&type=script&lang=js&"
import style0 from "./data-staff-info.vue?vue&type=style&index=0&id=fcf7ba3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf7ba3a",
  null
  
)

export default component.exports